<template>
  <div class="protocol-construct clear">
    <tabs
      :data="tabsData"
      v-model="activeIndex"
      :add="true"
      @add="onAddComponentClassify"
      @edit="onEditComponentClassify"
      @delete="onDelComponentClassify"
      :disabled="isDeriveProtocol"
    ></tabs>
    <div class="search-hd">
      <!-- 非衍生协议删除 -->
      <el-button
        type="primary"
        v-if="!isDeriveProtocol && isCurVersion"
        @click="delComponents"
        :disabled="selectedData.length === 0"
      >{{ $t('dms_protocol_item_construct.pi_liang_shan_chu') }}</el-button>
      <!-- 衍生协议删除 -->
      <el-button
        type="primary"
        v-if="isDeriveProtocol && isCurVersion"
        @click="deYSComponents"
        :disabled="selectedData.length === 0"
      >{{ $t('dms_protocol_item_construct.pi_liang_shan_chu') }}</el-button>
      <el-button
        type="primary"
        @click="onAddComponentItem"
        v-if="!isDeriveProtocol && isCurVersion"
      >
        <i class="el-icon-plus el-icon--left"></i>
        {{ $t('Common.com_add') }}
      </el-button>
      <el-button
        v-if="!isDeriveProtocol && isCurVersion"
        @click="onImport"
      >
        <i class="icon icon-daoru"></i>
        &nbsp;{{ $t('dms_protocol_item_construct.kuai_su_dao_ru') }}
      </el-button>
      <el-button
        v-if="isDeriveProtocol && isCurVersion"
        @click="onConstructSetting(info)"
      >
        <i class="el-icon-plus el-icon--left"></i>
        {{ $t('dms_protocol_item_construct.jie_gou_she_zhi') }}
      </el-button>
      <!-- 当前协议已经发布的情况下,衍生协议与定制协议在结构设置按钮后加上重新发布结构按钮 -->
      <el-button
        v-if="republishConstructVisible && isCurVersion"
        type="primary"
        @click="republish"
      >{{ $t('dms_protocol_item_construct.cxfbjg') }}</el-button>
      <el-radio-group
        v-if="isDeriveProtocol || isCustomizedProtocol"
        v-model="versionType"
        size="small"
        style="float: right"
      >
        <el-radio-button
          v-for="(item, index) in versionTypeData"
          :label="item.value"
          :key="index"
        >{{ item.label }}</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table-bd">
      <custom-table
        :data="curTableList"
        :column="tableColumn"
        :slots="['componentIcon', 'needTestTypes', 'hasData', 'action', 'componentName']"
        @filter="filterChange"
        @sort="sortChange"
        class="table"
        type="checkbox"
        v-model="selectedData"
        height="100%"
      >
        <template v-slot:componentName="scope">
          <div class="component-name">{{ scope.row.componentName }}</div>
        </template>
        <template v-slot:hasData="scope">
          {{ scope.row.hasData ? $t('dms_protocol_item_construct.you') : $t('dms_protocol_item_construct.wu') }}
        </template>
        <template v-slot:needTestTypes="scope">
          {{ getNeedTestTypes(scope.row.needTestTypes) || '-' }}
        </template>
        <template v-slot:componentIcon="scope">
          <div class="component-icon">
            <el-image
              v-if="getIconByAttachId(scope.row.componentIcon)"
              style="width: 100%; height: 100%"
              :src="getIconByAttachId(scope.row.componentIcon)"
              :preview-src-list="[getIconByAttachId(scope.row.componentIcon)]"
              fit="cover"
            ></el-image>
          </div>
        </template>
        <template v-slot:action="scope">
          <span>
            <el-button
              v-if="!isDeriveProtocol && isCurVersion"
              type="text"
              size="mini"
              @click="editComponent(scope.row)"
            >{{ $t('Common.com_edit') }}</el-button>
            <!-- 非衍生协议删除 -->
            <el-button
              v-if="!isDeriveProtocol && isCurVersion"
              type="text"
              size="mini"
              @click="delComponent(scope.row)"
            >{{ $t('Common.com_delete') }}</el-button>
            <!-- 衍生协议删除 -->
            <el-button
              v-if="isDeriveProtocol && isCurVersion"
              type="text"
              size="mini"
              @click="delYSComponent(scope.row)"
            >{{ $t('Common.com_delete') }}</el-button>
            <!-- 非衍生协议，显示数据存储设置 -->
            <el-button
              v-if="!isDeriveProtocol && isCurVersion"
              type="text"
              size="mini"
              @click="settingRelation(scope.row)"
            >
              {{ $t('dms_protocol_item_construct.sjccsz') }}
            </el-button>
            <el-button
              v-if="isDeriveProtocol"
              type="text"
              size="mini"
              @click="showSettingRelation(scope.row)"
            >{{ $t('dms_protocol_item_construct.cksjcc') }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <!-- 部件分组新增/编辑dialog -->
    <component-type-item-dialog
      :protocolCode="info.protocolCode"
      :activeIndex="activeIndex"
      :tabsData="tabsData"
      v-if="showComponentClassifyDialog"
      @close="showComponentClassifyDialog = false"
      :model="dialogModel1"
      @success="onAddComponentClassifySuccess"
    ></component-type-item-dialog>
    <!-- 部件详情新增/编辑dialog -->
    <component-item-dialog
      :protocolCode="info.protocolCode"
      v-if="showComponentItemDialog"
      @close="showComponentItemDialog = false"
      :model="dialogModel2"
      :classify-list="productStructureList"
      :parent-code="curComponentCode"
      @success="onAddComponentItemSuccess"
    ></component-item-dialog>
    <!-- 导入设备部件dialog -->
    <import-device-dialog
      :protocolCode="info.protocolCode"
      :model="dialogModel3"
      v-if="showImportDeviceDialog"
      @close="showImportDeviceDialog = false"
      @success="onImportDeviceSuccess"
    ></import-device-dialog>
    <!-- 结构设置 -->
    <construct-setting-dialog
      :protocolCode="info.protocolCode"
      :protocolClass="info.protocolClass"
      :model="dialogModel5"
      v-if="showConstructSettingDialog"
      @close="showConstructSettingDialog = false"
      @success="init"
    ></construct-setting-dialog>
    <!-- 设置表关系dialog -->
    <table-relation-setting-dialog
      v-if="showTableRelationSettingDialog"
      @close="showTableRelationSettingDialog = false"
      :componentId="componentItemModel.componentId"
      :model="dialogModel4"
    ></table-relation-setting-dialog>
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{ $t('dms_protocol_item_construct.sybxyxx') }}</el-button>
      <el-button
        type="primary"
        @click="onStep"
      >{{ $t('dms_protocol_item_construct.xia_yi_bu_wu_mo_xing') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tabs from '@/pages/dms/product/children/tabs.vue';
import componentTypeItemDialog from './component_type_item_dialog';
import componentItemDialog from './component_item_dialog.vue';
import importDeviceDialog from './import_device_dialog.vue';
import constructSettingDialog from './construct_setting_dialog.vue';
import tableRelationSettingDialog from './table_relation_setting_dialog.vue';
import mixins from './mixins';

export default {
  mixins: [mixins],
  props: {
    // productId: [Number, String],
    // productCode: String,
    // 1:标准协议 2:衍生协议 3:定制协议
    // 此协议是衍生协议时，通过此协议设置的结构从标准协议获取数据显示，此时不可使用
    // 新增，删除，快速导入，编辑，数据存储设置；衍生协议加上结构设置按钮
    // protocolType: String,
    // protocolCode: String,
    info: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    tabs,
    componentTypeItemDialog,
    componentItemDialog,
    importDeviceDialog,
    constructSettingDialog,
    tableRelationSettingDialog,
  },
  watch: {
    info: {
      immediate: true,
      handler(val) {
        if (val) {
          this.init();
        }
      },
    },
  },
  data() {
    return {
      tableCode: 'protocol_struct_list',
      tabsData: [],
      activeIndex: -1,
      productStructureList: [],
      showComponentClassifyDialog: false,
      showComponentItemDialog: false,
      componentClassifyModel: {},
      componentItemModel: {},
      showImportDeviceDialog: false,
      showConstructSettingDialog: false,
      showTableRelationSettingDialog: false,
      dialogModel1: {},
      dialogModel2: {},
      dialogModel3: {},
      dialogModel4: {},
      dialogModel5: {},
      bizType: 'iot.component.icon',
      iconList: [],
      formSearch: {},
      selectedData: [],
      versionType: '1',
    };
  },
  computed: {
    versionTypeData() {
      return [
        {
          label: this.$t('dms_protocol_item_construct.dang_qian_ban_ben'),
          value: '1',
        },
        {
          label: this.$t('dms_protocol_item_construct.fa_bu_ban_ben'),
          value: '2',
        },
      ];
    },
    // 是否为当前版本
    isCurVersion() {
      return this.versionType === '1';
    },
    // 是否为发布版本
    isPublishVersion() {
      return this.versionType === '2';
    },
    // 重新发布结构
    republishConstructVisible() {
      return (this.isDeriveProtocol || this.isCustomizedProtocol) && this.info.isPublish;
    },
    curTableList() {
      if (this.productStructureList && this.productStructureList.length) {
        if (this.activeIndex === -1) {
          const ret = [];
          this.productStructureList.forEach((item) => {
            ret.push(...(item.children || []));
          });
          return ret;
        }
        return this.productStructureList[this.activeIndex].children;
      }
      return [];
    },
    curComponentCode() {
      if (this.activeIndex === -1) {
        return '';
      }
      const item = this.productStructureList[this.activeIndex];
      if (item) {
        return item.componentCode;
      }
      return '';
    },
  },
  mounted: function () {
    this.getTableColumn();
    this.getIconList();
  },
  methods: {
    republish() {
      this.$showConfirm(this.$t('dms_protocol_item_construct.nqdycxfbjgm')).then(() => {
        const { protocolClass, protocolCode, protocolType, tcpVersion } = this.info;
        const reqData = {
          protocolClass,
          protocolCode,
          protocolType,
          tcpVersion,
        };
        this.$postJSON(apis.ComponentPublish, reqData, true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.init({ activeIndex: this.activeIndex });
        });
      });
    },
    getIconByAttachId(id) {
      if (this.iconList.length) {
        const item = this.iconList.find(obj => obj.bizId === id);
        return item ? this.getAttachUrl(item) : '';
      }
      return '';
    },
    getIconList() {
      this.$getJSON(apis.ComponentIconList, {}).then((res) => {
        const iconIds = res.data;
        this.$getAttachFileListType(iconIds, 'iot.component.icon').then((list) => {
          list.forEach((item) => {
            item.bizType = this.bizType;
          });
          this.iconList = list;
        });
      });
    },
    exportTableList() {
      // this.exportTable('ProductStructureExport', { productCode: this.productCode });
    },
    onImportDeviceSuccess() {
      this.init();
    },
    onImport() {
      this.dialogModel3.title = this.$t('dms_protocol_item_construct.kuai_su_dao_ru');
      this.showImportDeviceDialog = true;
    },
    onConstructSetting(row) {
      this.dialogModel5 = {
        title: this.$t('dms_protocol_item_construct.jie_gou_she_zhi'),
        data: row,
      };
      this.showConstructSettingDialog = true;
    },
    async onDelComponentClassify(index) {
      // if (this.isDeriveProtocol) {
      //   return;
      // }

      const item = this.productStructureList[index];
      const cfTips = this.$t('dms_protocol_item_construct.nqdyscxzdbjfzm');
      if (await this.$boolPromise(this.$showConfirm(cfTips))) {
        if (item.children && item.children.length) {
          this.$message({
            message: this.$t('dms_protocol_item_construct.qxscgflxdbj'),
            type: 'warning',
          });
          return;
        }
        this.$postJSON(`${apis.ComponentDelete}/${item.componentId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          const activeIndex = this.productStructureList.length - 1 === index ? Math.max(-1, this.productStructureList.length - 2) : this.activeIndex;
          this.init({ activeIndex });
        });
      }
    },
    onEditComponentClassify(index) {
      if (this.isDeriveProtocol) {
        return;
      }
      this.dialogModel1.type = 'edit';
      this.dialogModel1.title = this.$t('dms_protocol_item_construct.bjbjfz');
      this.dialogModel1.data = this.productStructureList[index];
      this.showComponentClassifyDialog = true;
    },
    onAddComponentClassify() {
      if (this.isDeriveProtocol) {
        return;
      }
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('dms_protocol_item_construct.xzbjfz');
      this.showComponentClassifyDialog = true;
    },
    onAddComponentItemSuccess() {
      this.init({ activeIndex: this.activeIndex });
    },

    onPageChange() {
      this.init({ activeIndex: this.activeIndex });
    },

    async onAddComponentClassifySuccess() {
      this.init({ activeIndex: this.activeIndex });
      // const productStructureList = await this.getProductStructureList();
      // this.getIconList();
      // const tabsData = this.productStructureListToTabsData(productStructureList);
      // this.tabsData = tabsData;
      // this.productStructureList = productStructureList;
    },
    onAddComponentItem() {
      this.dialogModel2.type = 'add';
      this.dialogModel2.title = this.$t('dms_protocol_item_construct.xzxyjg');
      this.showComponentItemDialog = true;
    },
    editComponent(row) {
      this.dialogModel2.type = 'edit';
      this.componentItemModel = row;
      this.dialogModel2.data = row;
      this.dialogModel2.title = this.$t('dms_protocol_item_construct.bjxyjg');
      this.showComponentItemDialog = true;
    },
    settingRelation(row) {
      this.componentItemModel = row;
      this.dialogModel4.title = this.$t('dms_protocol_item_construct.sjccsz');
      this.dialogModel4.type = 'edit';
      this.showTableRelationSettingDialog = true;
    },
    showSettingRelation(row) {
      this.componentItemModel = row;
      this.dialogModel4.title = this.$t('dms_protocol_item_construct.cksjcc');
      this.dialogModel4.type = 'watch';
      this.showTableRelationSettingDialog = true;
    },
    delComponent(row) {
      this.$showConfirm(this.$t('dms_protocol_item_construct.nqdyscxzdxyjgm')).then(() => {
        this.deleteComponent(row.componentId).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.init({ activeIndex: this.activeIndex });
        });
      });
    },
    delComponents() {
      this.$showConfirm(this.$t('dms_protocol_item_construct.nqdyscxzdxyjgm')).then(() => {
        const list = this.selectedData;
        const ids = list.map(item => item.componentId);
        this.deleteComponent(ids).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.init({ activeIndex: this.activeIndex });
        });
      });
    },
    deleteComponent(id) {
      const ids = Array.isArray(id) ? [...id] : [id];
      return this.$postJSON(apis.ComponentBatchDelete, ids, true);
    },
    // 衍生协议删除
    delYSComponent(row) {
      this.$showConfirm(this.$t('dms_protocol_item_construct.nqdyscxzdxyjgm')).then(() => {
        this.deleteYSComponent(row.componentCode).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.init({ activeIndex: this.activeIndex });
        });
      });
    },
    deYSComponents() {
      this.$showConfirm(this.$t('dms_protocol_item_construct.nqdyscxzdxyjgm')).then(() => {
        const list = this.selectedData;
        const codes = list.map(item => item.componentCode);
        this.deleteYSComponent(codes).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.init({ activeIndex: this.activeIndex });
        });
      });
    },
    deleteYSComponent(code) {
      const protocolCode = this.info.protocolCode;
      const url = `${apis.DerivedComponentDelete}/${protocolCode}`;
      const codes = Array.isArray(code) ? [...code] : [code];
      return this.$postJSON(url, codes, true);
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    // 下一步
    onStep: function () {
      this.$emit('step', { name: 'component' });
    },
    async getProductStructureList() {
      // // 1:标准协议 2:衍生协议 3:定制协议 protocolType
      const url = this.isDeriveProtocol ? apis.DerivedComponentRelationList : apis.ComponentList;
      return this.$getJSON(url, {
        protocolCode: this.info.protocolCode,
        ...this.formSearch,
      }).then(res => res.data);
    },
    productStructureListToTabsData(list) {
      return list.map(item => ({
        label: item.componentName,
      }));
    },
    async init(options = {}) {
      this.activeIndex = options.activeIndex === undefined ? -1 : options.activeIndex;
      const productStructureList = await this.getProductStructureList();
      this.getIconList();
      const tabsData = this.productStructureListToTabsData(productStructureList);
      this.tabsData = tabsData;
      this.productStructureList = productStructureList;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.protocol-construct {
  display: flex;
  flex-direction: column;
  height: 100%;
  .protocol-construct-info {
  }

  .component-name {
    height: 40px;
    line-height: 40px;
  }

  .el-table--mini.table td {
    padding: 0 !important;
  }

  .icon {
    font-size: 14px;
  }

  .footer {
    z-index: 10;
  }

  .component-icon {
    position: relative;
    max-width: 65px;
    max-height: 40px;

    .el-image {
      float: left;
    }

    // position: relative;
    // .icon-img {
    //   position: absolute;
    //   left: 0;
    //   right: 0;
    //   top: 0;
    //   bottom: 0;
    //   max-width: 100%;
    //   max-height: 100%;
    //   margin: auto;
    // }
  }
}
</style>
